module.exports = __webpack_public_path__ + "img/nseguidores.92e94edc.svg";